import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { BRAND_GRADIENT } from '@presentation/styling/gradients';

export const Wrapper = styled('footer')(({ theme }) => ({
	width: '100%',
	padding: `${theme.spacing(6)} 0`,
	background: BRAND_GRADIENT,
	marginTop: theme.spacing(6),
}));

export const TopGrid = styled(Grid)(() => ({}));

export const Brand = styled(Typography)(({ theme }) => ({
	fontSize: 22,
	fontWeight: 800,
	letterSpacing: '-0.02em',
	color: theme.colors.text,
	marginBottom: theme.spacing(2),
}));

export const Paragraph = styled(Typography)(({ theme }) => ({
	fontSize: 16,
	lineHeight: 1.7,
	color: theme.colors.text,
	maxWidth: 460,
	marginBottom: theme.spacing(3),
	textWrap: 'balance',
	[theme.breakpoints.up('md')]: {
		fontSize: 17,
	},
}));

export const Badges = styled('div')(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	gap: theme.spacing(1.5),
}));

export const DownloadButton = styled('img')(() => ({
	display: 'block',
	height: 44,
	width: 'auto',
}));

export const Title = styled(Typography)(({ theme }) => ({
	fontSize: 13,
	fontWeight: 700,
	textTransform: 'uppercase',
	letterSpacing: '0.08em',
	color: theme.colors.text,
	marginBottom: theme.spacing(2),
}));

export const BottomNavigationLink = styled(Link)(({ theme }) => ({
	display: 'block',
	fontSize: 15,
	fontWeight: 400,
	textDecoration: 'none',
	color: theme.colors.text,
	marginBottom: theme.spacing(1.5),
	transition: 'color 0.15s ease',
	'&:hover': {
		color: theme.colors.brand,
	},
}));
